import { useState, useEffect } from "react";
import { Users, FolderOpen, CreditCard } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const LiveCounter = () => {
  const { t } = useLanguage();
  const [counters, setCounters] = useState({
    professionals: 847,
    projects: 2341,
    payments: 156780,
    online: 23,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCounters(prev => ({
        professionals: prev.professionals + (Math.random() > 0.7 ? 1 : 0),
        projects: prev.projects + (Math.random() > 0.5 ? Math.floor(Math.random() * 2) : 0),
        payments: prev.payments + Math.floor(Math.random() * 500),
        online: Math.max(15, Math.min(50, prev.online + Math.floor(Math.random() * 5) - 2)),
      }));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const formatNumber = (num: number) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + "M";
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + "k";
    }
    return num.toLocaleString("pt-BR");
  };

  const formatCurrency = (num: number) => {
    if (num >= 1000000) {
      return "R$ " + (num / 1000000).toFixed(1) + "M";
    }
    if (num >= 1000) {
      return "R$ " + (num / 1000).toFixed(0) + "k";
    }
    return "R$ " + num.toLocaleString("pt-BR");
  };

  return (
    <div className="flex flex-wrap justify-center gap-4 sm:gap-6 lg:gap-8">
      <div className="flex items-center gap-2 px-4 py-2 bg-green-500/10 border border-green-500/20 rounded-full">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
        </span>
        <span className="text-sm font-medium text-green-500">
          {counters.online} {t('counter.online')}
        </span>
      </div>

      <div className="flex items-center gap-2 px-4 py-2 bg-primary/10 border border-primary/20 rounded-full">
        <Users className="w-4 h-4 text-primary" />
        <span className="text-sm font-medium text-foreground">
          <span className="text-primary font-bold transition-all duration-300">
            {formatNumber(counters.professionals)}
          </span>
          {" "}{t('counter.professionals')}
        </span>
      </div>

      <div className="flex items-center gap-2 px-4 py-2 bg-primary/10 border border-primary/20 rounded-full">
        <FolderOpen className="w-4 h-4 text-primary" />
        <span className="text-sm font-medium text-foreground">
          <span className="text-primary font-bold transition-all duration-300">
            {formatNumber(counters.projects)}
          </span>
          {" "}{t('counter.projects')}
        </span>
      </div>

      <div className="flex items-center gap-2 px-4 py-2 bg-primary/10 border border-primary/20 rounded-full">
        <CreditCard className="w-4 h-4 text-primary" />
        <span className="text-sm font-medium text-foreground">
          <span className="text-primary font-bold transition-all duration-300">
            {formatCurrency(counters.payments)}
          </span>
          {" "}{t('counter.charges')}
        </span>
      </div>
    </div>
  );
};

export default LiveCounter;
